import { Link } from "react-router-dom";

// The webinars platform footer: what the platform is, then two link groups. The privacy notice
// has its own page (/events/privacy) so it can be linked and shared. No admin link: the Client
// Admin button in the header is the only way in, and it's protected by sign-in.
export default function EventsFooter() {
  return (
    <footer className="evp-footer">
      <div className="km-container evp-footer-inner">
        <div className="evp-footer-about">
          <strong>Kole Medical Webinars &amp; Workshops</strong>
          <p>Online sessions on medical devices and reagents in South Africa. Open to everyone.</p>
        </div>
        <nav className="evp-footer-group" aria-label="Explore">
          <h2>Explore</h2>
          <ul>
            <li><Link to="/events">Upcoming webinars</Link></li>
            <li><Link to="/news">News and updates</Link></li>
            <li><Link to="/">Kole Medical main site</Link></li>
          </ul>
        </nav>
        <nav className="evp-footer-group" aria-label="Registration and support">
          <h2>Registration &amp; support</h2>
          <ul>
            <li><Link to={{ pathname: "/events", hash: "#how" }}>How registration works</Link></li>
            <li><Link to="/events/privacy">Privacy notice</Link></li>
            {/* For registration or joining-link problems */}
            <li><Link to="/query">Contact Kole Medical</Link></li>
          </ul>
        </nav>
      </div>
      <div className="km-container evp-footer-bottom">
        <p>&copy; 2026 KOLE MEDICAL (PTY) LTD · All rights reserved · All event times shown in SAST</p>
      </div>
    </footer>
  );
}
